const wheelOptions: AddEventListenerOptions = { passive: false };

/**
 * Evita que la rueda del ratón cambie el valor de los inputs numéricos (comportamiento por defecto del navegador).
 * Solo actúa cuando el evento ocurre sobre el propio input, para no interferir con el scroll del documento o modales.
 */
export function installNumberInputWheelGuard(): () => void {
  const onWheel = (e: WheelEvent) => {
    if (e.target instanceof HTMLInputElement && e.target.type === 'number') {
      e.preventDefault();
    }
  };

  document.addEventListener('wheel', onWheel, wheelOptions);
  return () => document.removeEventListener('wheel', onWheel, wheelOptions);
}
